var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn",
    staticStyle: {
      "margin-top": "1%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-shopping-bag highlight-icon bg-primary p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("Total Bags")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.totalbags))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-dropbox highlight-icon bg-success p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("Open Bags")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.bagopen))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-times-circle highlight-icon bg-warning p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("Closed Bags")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.bagclosed))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-clock-o highlight-icon bg-info p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("Scheduled Bags")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.scheduled))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-barcode highlight-icon bg-danger p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("Outscan Bags")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.outscan))])])], 1)])]), _vm._v(" "), (_vm.isPaperworkShortageEnabled) ? _c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.redirectCRMLink
    }
  }, [_vm._m(0)])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-dashboard highlight-icon p-3 font-2xl mr-3",
    staticStyle: {
      "color": "#fff",
      "background-color": "#F68607"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("CRM Dashboard")]), _vm._v(" "), _c('strong', [_c('i', {
    staticClass: "fa fa-external-link"
  })])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a1cf10e","hasScoped":true}!./src/views/components/dashboard/dashboard.component.html
// module id = 520
// module chunks = 2